export default __webpack_public_path__ + "static/media/49.0202bd3a.png";